import { Button } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import FreeLeadsModal from 'components/providers/FreeLeadsModal'

interface Props {
    providerId: number
}

const FreeLeadsButton = ({ providerId }: Props) => {
    return (
        <Button onClick={() => NiceModal.show(FreeLeadsModal, { providerId })} name="text">
            Give away free leads
        </Button>
    )
}

export default FreeLeadsButton
